import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { sweetalert } from "../services/sweetalert";
import { GeolocationService } from "../services/geolocationservice";

@Component({
  selector: "app-dealer-locator",
  templateUrl: "./dealer-locator.component.html",
  styleUrls: ["./dealer-locator.component.css"],
})
export class DealerLocatorComponent implements OnInit {
  loader: boolean = false;
  responseData: any;
  dlrList = [];
  dataList = [];
  encrpyData:any;
  lat:any;
  lng:any;
  constructor(
    private alert: sweetalert,
    private route: Router,
    private service: GeolocationService,
    private activatedRoute:ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loader = true;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.encrpyData= params['data'] != null ? params["data"]: null;
      this.lat = params["lat"] != null ? params["lat"] : null;
      this.lng = params["lng"] != null ? params["lng"] : null;
      console.log("encrpyData:"+this.encrpyData);
      
      if(this.encrpyData==null){
        this.encrpyData=localStorage.getItem("encrpyData");
      }
      if(this.lat==null && this.lng==null){
        this.lat=localStorage.getItem("ml_lat");
        this.lng=localStorage.getItem("ml_lng");
      }
      localStorage.setItem("encrpyData",this.encrpyData);
      localStorage.setItem("ml_lat",this.lat);
      localStorage.setItem("ml_lng",this.lng);
      (error) => {
        console.error("Unable to Process");
      };
    });
    this.loader = false;
  }

  redirectToDearlerPage(portFolio: string) {
    console.log({ portFolio });
    let reqData = {
      portfolio: portFolio,
      encrpyData:this.encrpyData,
      lat:this.lat,
      lng:this.lng
    };
    this.loader = true;
    this.service.getMerchantStoreDealers(reqData).subscribe(
      (data: any) => {
        if (typeof data === "object") {
          this.responseData = JSON.parse(data.data);
          //console.log("responseData:" + JSON.stringify(this.responseData));
          if (data.statusCode == "EX") {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
            this.alert.errorsweertalert(this.responseData.statusMessage);
          } else if (data.statusCode == "SR") {
            this.responseData.DEALERS.filter((e: any) => {
              let obj = e;
              let imgObj = {};
              let merObj = {};
              if ("DEALER_TYPE" in e) {
                imgObj = this.responseData.IMG_DETAILS.filter(
                  (e) => e.IMG_NAME == "IMAGE_TW_DEALER"
                );
              } else if ("CD" in e && "MOB" in e) {
                if (e.CD == "Y" && e.MOB == "Y") {
                  imgObj = this.responseData.IMG_DETAILS.filter(
                    (e) => e.IMG_NAME == "IMAGE_MOBILE_AND_HOME_APP"
                  );
                } else if (e.CD == "Y" && e.MOB == "N") {
                  imgObj = this.responseData.IMG_DETAILS.filter(
                    (e) => e.IMG_NAME == "IMAGE_HOME_APP"
                  );
                } else if (e.CD == "N" && e.MOB == "Y") {
                  imgObj = this.responseData.IMG_DETAILS.filter(
                    (e) => e.IMG_NAME == "IMAGE_MOBILE_STORE"
                  );
                }
              }
              const { IMG_NAME: _, ...newObj } = imgObj[0];
              merObj = Object.assign(obj, newObj);
              this.dlrList.push(merObj);
            });
            console.log("dltList:" + JSON.stringify(this.dlrList));
            console.log(JSON.stringify(this.dataList));
            let dataList = {
              DEALERS: this.dlrList,
              CATEGORY: this.responseData.CATEGORY,
            };
            localStorage.setItem("dealerData", JSON.stringify(dataList));
            setTimeout(() => {
              this.loader = false;
            }, 1000);
            this.route.navigate(["dealers"]);
          }
        }
      },
      (error: Response) => {
        this.alert.errorsweertalert("Something went wrong");

        this.loader = false;
      }
    );
  }
}
